import type { ClientMessage, FocusState, PeerState } from './message';
import { hasState } from './peers';

/** What this tab tells the others on the entity it has joined. */
export interface EntityPublisher {
  focus(focus: FocusState): void;
  /** Re-sends the full current state, for late joiners and as a heartbeat. */
  announce(): void;
}

/** Remembers what we last said so `announce` can repeat it. One per entity channel. */
export function createEntityPublisher(send: (message: ClientMessage) => void): EntityPublisher {
  const state: PeerState = {};

  return {
    focus(focus) {
      state.focus = focus.field === null ? undefined : focus;
      send({ type: 'focus', data: focus });
    },
    announce() {
      if (hasState(state)) send({ type: 'state', data: { ...state } });
    },
  };
}
